export default __webpack_public_path__ + "static/media/limon.067dd97a.jpg";